(function () {
  'use strict';

  angular
    .module('specsguardApp')
    .service('TechElementSubmoduleService', TechElementSubmoduleService);

  TechElementSubmoduleService.$inject = ['errorMessageService', 'Labels', 'SimpleDialogFormService', 'Constants', 'TechnicalElementsAPI'];

  function TechElementSubmoduleService (errorMessageService, Labels, SimpleDialogFormService, Constants, TechnicalElementsAPI) {


    let confirmOptionsLabels = {};

    init();

    return {
      open: openModal,
      confirmDelete: confirmDelete
    };

    // ////////////

    function init () {
      confirmOptionsLabels = {
        title: Labels.getLabel('editsubmodule'),

        fields: [
          {
            key: 'name',
            label: Labels.getLabel('submodulename'),
            required: true,
            type: 'text'
          },
          {
            key: 'protected',
            label: Labels.getLabel('protected'),
            required: false,
            type: 'checkbox'
          },
        ],

        save: function (form, instance) {
          form.active = true;
          if (instance.module && instance.module._id) {
            form.moduleId = instance.module._id;
          }

          if (instance && instance._id) {
            return TechnicalElementsAPI.updateSubModule({submodule: form, id: instance._id}).$promise;
          }

          return TechnicalElementsAPI.createSubModule({submodule: form}).$promise;
        }
      };
    }

    function openModal (ev, instance) {
      return SimpleDialogFormService.open(ev, confirmOptionsLabels, instance);
    }

    function confirmDelete (ev, instance) {
      let options = {
        title: Labels.getLabel('deletesubmoduletitle'),
        content: Labels.getLabel('areyousuredeletesubmodule'),
        warning: Labels.getLabel('thisactioncannotbeundone'),
        ok: Labels.getLabel('delete'),
        ok_icon: 'delete',
        cancel: Labels.getLabel('cancel')
      };
      return SimpleDialogFormService.confirm(ev, options, instance).then(() => removeTechSubModule(instance));
    }

    function removeTechSubModule (techSubModule) {
      techSubModule.active = false;
      const updatedSubModule = {id: techSubModule._id, submodule: techSubModule};
      return TechnicalElementsAPI.updateSubModule(updatedSubModule).$promise;
    };

  }
})();
